export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/theme/components/scorecard/MetricsLabels/index.js